import { t } from "i18next";
import { useAppDispatch } from "../../state/hooks";
import { openStandardModal } from "../../state/slice/modal/modalSlice";
import type { AppDispatch } from "../../state/store";
import { ButtonText } from "../Button";
import { useEditButtonFlash } from "./useEditButtonFlash";

type ListItemProps = {
  title: string;
  disabled?: boolean;
  setDisabled?: (arg: boolean) => void;
  avatarStatus?: string;
  setFocus?: () => void;
  children?: React.ReactNode;
  setValueFct?: unknown;
  onPickImage?: () => void;
};

export const profileRowClassName =
  "w-full flex flex-col sm:flex-row items-center py-2 px-2 xl:py-3 xl:px-4 border-t border-gray-300";

const ProfileInputStyle = ({
  title,
  disabled,
  setDisabled,
  avatarStatus,
  setFocus,
  children,
  onPickImage,
}: ListItemProps) => {
  const dispatch: AppDispatch = useAppDispatch();
  const { flashClassName, flash } = useEditButtonFlash();

  const isAvatarField = title === t("general.avatar");
  const isRoleField = title === t("general.roles.role");
  const isPasswordField = title === t("general.password");
  const isPhotoField = title === t("pages.profile.main.photo");
  const isEmailField = title === t("general.email");
  const editLocked = !isRoleField && disabled !== false;

  return (
    <div className={profileRowClassName}>
      <p className="w-full sm:w-1/3 text-sm text-center sm:text-left">{title}</p>
      <div className="contents" onClickCapture={editLocked ? flash : undefined}>
        {children}
      </div>
      <div className="flex grow justify-end">
        {isAvatarField && avatarStatus !== "loading" && (
          <div className="border-r-[1px] mr-2 pr-2 border-gray-300">
            <ButtonText
              type="button"
              text={t("general.preview")}
              onClick={() => {
                dispatch(openStandardModal("modalPreviewAvatar3d"));
              }}
            />
          </div>
        )}

        {!isRoleField && !isAvatarField && (
          <ButtonText
            type="button"
            text={t("general.edit")}
            className={flashClassName}
            onClick={() => {
              if (isPasswordField) {
                dispatch(openStandardModal("modalConfirmPassword"));
              } else if (isPhotoField) {
                onPickImage?.();
              } else if (isEmailField) {
                dispatch(openStandardModal("modalConfirmPasswordForEmail"));
              } else {
                if (setDisabled) {
                  setDisabled(!disabled);
                }
              }
              if (setFocus) {
                setFocus();
              }
            }}
          />
        )}
        {isAvatarField && (
          <ButtonText
            type="button"
            text={t("general.edit")}
            className={flashClassName}
            onClick={() => {
              dispatch(openStandardModal("modalEditAvatar3d"));
            }}
          />
        )}
      </div>
    </div>
  );
};

export default ProfileInputStyle;
